import "core-js/modules/es.number.constructor.js";
import SupplierSelectComponent from "@/components/supplier-prices/SupplierSelectComponent.vue";
export default {
  name: "NewSupplierPriceComponent",
  components: {
    SupplierSelectComponent: SupplierSelectComponent
  },
  props: {
    suppliers: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    isLoading: {
      type: Boolean,
      default: false
    },
    isAdding: {
      type: Boolean,
      default: false
    },
    wineId: {
      type: Number,
      default: null
    }
  },
  data: function data() {
    return {
      formAdd: {
        supplierId: null,
        price: null,
        comment: null
      },
      boolRender: false
    };
  },
  computed: {
    isInvalidForm: function isInvalidForm() {
      var _this = this;
      var nullishPredicate = function nullishPredicate(x) {
        return !_this.wineId || !x.supplierId || !x.price || x.price <= 0;
      };
      if (nullishPredicate(this.formAdd)) return true;
      return false;
    }
  },
  methods: {
    addSupplierPrice: function addSupplierPrice() {
      this.formAdd.wineId = this.wineId;
      this.$emit("addSupplierPrice", this.formAdd);
    },
    fetchSuppliersWhenItemsUpdated: function fetchSuppliersWhenItemsUpdated() {
      this.$emit("fetchSuppliersWhenItemsUpdated");
    },
    changeSupplier: function changeSupplier(supplierId) {
      this.formAdd.supplierId = supplierId;
    },
    cleanComment: function cleanComment() {
      this.formAdd.comment = null;
    },
    updateModelSelect: function updateModelSelect(supplierId) {
      this.$refs.supplierSelect.updateModel(supplierId);
    },
    setCogs: function setCogs(cogs) {
      this.formAdd.price = cogs;
    },
    setSupplier: function setSupplier(supplierId) {
      this.formAdd.supplierId = supplierId;
      this.boolRender = !this.boolRender;
    }
  }
};